<template>
  <el-form-item :label="label" class="struct-form-item">
    <div class="form-item-content">
      <el-form-item
        :prop="jsonProps"
        :rules="[{ validator: validateJson, trigger: 'change' }]"
        style="margin-bottom:0;"
      >
        <table class="json-table">
          <tbody>
            <tr>
              <td class="td-head" width="80px">{{ $t('Common.number') }}</td>
              <td class="td-head" width="360px">{{ $t('Product.paramName') }}</td>
              <td class="td-head" width="160px">{{ $t('Common.operation') }}</td>
            </tr>
            <tr v-for="(item, index) in form[jsonProps]" :key="index">
              <td>{{ index + 1 }}</td>
              <td>
                <el-select
                  v-model="item.data"
                  filterable
                  :placeholder="$t('Common.tipsSelect1')"
                  value-key="identifier"
                >
                  <el-option
                    v-for="item in propertyData"
                    :key="item.identifier"
                    :label="item.name"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </td>
              <td>
                <!-- <hl-button type="text" @click="handleJsonEdit(json, index)">编辑</hl-button> -->
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('Common.delete')"
                  placement="top-start"
                >
                  <hl-button type="text" @click="handleJsonDel(index)">
                    <!--                  {{$t('Common.delete') }}-->
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-del_16"></use>
                    </svg>
                  </hl-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('Common.moveDown')"
                  placement="top-start"
                >
                  <hl-button
                    v-if="index < form[jsonProps].length - 1"
                    type="text"
                    @click="handleMove(index, 'down')"
                  >
                    <!--                  {{ $t('Common.moveDown') }}-->
                    <!--                    <svg class="icon" aria-hidden="true">-->
                    <!--                      <use xlink:href="#icon-arrow"></use>-->
                    <!--                    </svg>-->
                    <svg class="icon" aria-hidden="true" style="transform: rotate(180deg)">
                      <use xlink:href="#icon-top_arrow_16"></use>
                    </svg>
                  </hl-button>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('Common.moveUp')"
                  placement="top-start"
                >
                  <hl-button v-if="index > 0" type="text" @click="handleMove(index, 'up')">
                    <!--                  {{$t('Common.moveUp')}}-->
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-top_arrow_16"></use>
                    </svg>
                  </hl-button>
                </el-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </el-form-item>
      <div class="add-btn" @click="handnleJsonAdd">
        <svg class="icon">
          <use xlink:href="#icon-add"></use>
        </svg>
        <span>{{ $t('Product.addParam') }}</span>
      </div>
    </div>
  </el-form-item>
</template>

<script>
export default {
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object
    },
    label: {
      type: String,
      default: ''
    },
    needComplexDatatype: {
      type: Boolean,
      default: true
    },
    jsonProps: {
      type: String
    }
  },
  data() {
    return {
      propertyData: []
    }
  },
  created() {
    this.queryProperty()
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.formatParams()
      }
    }
  },
  methods: {
    queryProperty() {
      const params = {
        productKey: this.$route.query.pk,
        draft: true
      }
      this.$ajax
        .get(this.$api.product.product_tsl_property_list, params)
        .then((res) => {
          if (res.data) {
            this.propertyData = res.data
          }
        })
        .catch(() => {})
    },
    onPropertyChange(data, index) {
      const i = this.form[this.jsonProps].findIndex(
        (item) => item.name === data.name && item.identifier === data.identifier
      )
      if (i !== index) {
        this.$message.warning(`${this.$t('Product.tips21')}`)
      }
    },
    formatParams() {
      if (!this.form[this.jsonProps] || this.form[this.jsonProps].length <= 0) return
      // 已经处理过了也不用处理了
      if (this.form[this.jsonProps][0].data) return
      this.form[this.jsonProps] = this.form[this.jsonProps].map((item) => {
        return {
          data: {
            ...item
          }
        }
      })
    },
    validateJson(rule, value, callback) {
      if (this.form[this.jsonProps]) {
        const identifiers = this.form[this.jsonProps].map((item) => item.data.identifier)
        const identifierSet = new Set(identifiers)
        if (identifierSet.size !== identifiers.length) {
          callback(new Error(`${this.$t('Product.tips21')}`))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    handnleJsonAdd() {
      if (!this.form[this.jsonProps]) {
        this.form[this.jsonProps] = []
      }
      this.form[this.jsonProps].push({
        data: {}
      })
    },
    handleJsonEdit(json, index) {
      this.currJson = json
      this.currJsonIndex = index
      this.jsonVisible = true
    },
    handleJsonDel(index) {
      this.form[this.jsonProps].splice(index, 1)
    },
    handleMove(index, type) {
      const curr = this.form[this.jsonProps][index]
      this.form[this.jsonProps].splice(index, 1)
      if (type === 'up') {
        // 上移
        this.form[this.jsonProps].splice(index - 1, 0, curr)
      } else {
        // 下移
        this.form[this.jsonProps].splice(index + 1, 0, curr)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-content {
  width: 580px;
  padding: 16px;
  background: #f4f8fe;
  border-radius: 0px 16px 16px 16px;
}
.add-btn {
  width: 100%;
  margin-top: 16px;
  line-height: 1;
  text-align: center;
  padding: 6px 0;
  border: 2px dashed rgba(218, 223, 230, 1);
  border-radius: 4px;
  font-size: 14px;
  color: $--color-blue;
  cursor: pointer;
  .icon {
    margin-right: 1px;
  }
}
</style>
